import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clubName", "shortName", "shortNameExample"]
  static values = { url: String, exampleBaseUrl: String }

  connect() {
    this.lastRequestedClubName = null
    this.shortNameTouched = this.shortNameTarget.value.trim().length > 0
    this.updateShortNameExample()
  }

  queueSuggestion() {
    if (this.shortNameTouched || this.shortNameTarget.value.trim().length > 0) return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.fetchSuggestion(), 250)
  }

  markShortNameTouched() {
    this.shortNameTouched = this.shortNameTarget.value.trim().length > 0
    this.updateShortNameExample()
  }

  async fetchSuggestion() {
    const clubName = this.clubNameTarget.value.trim()
    if (clubName.length === 0) return
    if (this.shortNameTouched || this.shortNameTarget.value.trim().length > 0) return
    if (clubName === this.lastRequestedClubName) return

    this.lastRequestedClubName = clubName
    this.abortController?.abort()
    this.abortController = new AbortController()

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("club_name", clubName)

    try {
      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })

      if (!response.ok) return

      const data = await response.json()
      if (this.shortNameTouched || this.shortNameTarget.value.trim().length > 0) return

      this.shortNameTarget.value = data.short_name || ""
      this.updateShortNameExample()
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }

  updateShortNameExample() {
    const shortName = this.shortNameTarget.value.trim() || "southside-swans"
    this.shortNameExampleTarget.textContent = `${this.exampleBaseUrlValue}/club/${shortName}`
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.abortController?.abort()
  }
}
